module.exports = __webpack_public_path__ + "img/autospin_btn.acd75bad.png";